import { EMPTY, interval, startWith, switchMap, type Observable } from "rxjs";
import { isConsoleSessionLost } from "@/lib/auth/consoleSessionLost";

/**
 * Returns an observable that emits at the given interval, and on each tick
 * subscribes to the observable returned by `fetch`. Each new emission from
 * `interval` cancels the previous subscription (switchMap). Use for polling
 * APIs. Ticks are skipped while the console session is being replaced by login.
 */
export const createPollingStream = <T>(
  intervalMs: number,
  fetch: () => Observable<T>,
): Observable<T> => {
  return interval(intervalMs).pipe(
    startWith(0),
    switchMap(() => (isConsoleSessionLost() ? EMPTY : fetch())),
  );
};
